export interface II9GovernmentDocument {
    IssuingAuthority: string
    DocumentNumber: string
    ExpirationDate: string | Date
    Image: string
    ImageId: string
    ListType: EListType
    DocumentType: EDocumentType
}

export enum EListType {
    A = 0,
    B = 1,
    C = 2,
}

export enum EDocumentType {
    ListA_USPassport = 0,
    ListA_PermanentResidentCard = 1,
    ListA_ForeignPassport = 2,
    ListA_EmploymentAuthorization = 3,
    ListA_NonImmigrantAuthorizedAlienForeignPassport = 4,
    ListA_NonImmigrantAuthorizedAlienI94 = 5,
    ListA_FSMPassport = 6,

    ListB_DriversLicense = 7,
    ListB_FederalStateLocalGovernmentPhotoId = 8,
    ListB_SchoolPhotoId = 9,
    ListB_VoterRegistrationCard = 10,
    ListB_USMillitaryCard = 11,
    ListB_MillitaryDependentsIdCard = 12,
    ListB_USCoastGaurdMerchantMarinerCard = 13,
    ListB_NativeAmericanTribalDocument = 14,
    ListB_CanadianDriversLicense = 15,
    ListB_SchoolRecordOrReportCard = 16,
    ListB_ClinicDoctorOrHospitalRecord = 17,
    ListB_DayCareOrNurserySchoolRecord = 18,

    ListC_SSNCard = 19,
    ListC_StateDepartmentIssuedBirthCertificateFromAbroad = 20,
    ListC_StateDepartmentIssuedReportOfBirthCertificate = 21,
    ListC_BirthCertificate = 22,
    ListC_NativeAmericanTribalDocument = 23,
    ListC_USCitizenIdCard = 24,
    ListC_IdentificationCardForUseofResidentCitizenInUSA = 25,
    ListC_EmploymentAuthorizationDocumentFromDHS = 26,
}